var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 283,
    viewBox: "0 0 332 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.711 0H153.99C223.503 0 276.194 37.3626 295.797 91.7297H331.395V124.59H303.293C303.843 129.783 304.124 135.073 304.124 140.448V141.255C304.124 147.306 303.769 153.255 303.074 159.081H331.395V191.941H295.119C275 245.552 222.717 282.558 153.99 282.558H39.711V191.941H0V159.081H39.711V124.59H0V91.7297H39.711V0ZM71.6589 191.941V253.08H153.99C204.796 253.08 242.543 228.593 260.114 191.941H71.6589ZM269.901 159.081H71.6589V124.59H269.952C270.687 130.018 271.062 135.582 271.062 141.255V142.062C271.062 147.866 270.67 153.548 269.901 159.081ZM153.99 29.4294C205.03 29.4294 242.89 54.5624 260.355 91.7297H71.6589V29.4294H153.99Z",
    fill: "#F4B731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDai);
export default __webpack_public_path__ + "static/media/dai.d772def5b82bf50af63ebc39fbb94060.svg";
export { ForwardRef as ReactComponent };